import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { ReactComponent } from '@sketch/icons/lock-16';
import { RowIcon } from './ProjectLogo.styles.js';

const RestrictedProjectLogoBase = ({ className }) => (jsx(RowIcon, Object.assign({ className: className }, { children: jsx(ReactComponent, {}) })));
const ProjectLogo = styled(RestrictedProjectLogoBase) ``;

export { ProjectLogo };
